import { select } from '@js/util/select'

// Ratio of the hero media to be scrolled out of view to hide the scroll indicator
const HIDE_INDICATOR_RATIO = 0.2

const threshold = 1 - HIDE_INDICATOR_RATIO

let observer = new IntersectionObserver(
  entries => {
    entries[0].target.classList.toggle(
      'hero-show-scroll-indicator',
      entries[0].intersectionRatio > threshold,
    )
  },
  { threshold },
)

// Pause video when out of view to spare computation cycles
select('.hero-section.hero-is-video', element => {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const video = entry.target.querySelector('video')
      if (!video) continue
      if (entry.isIntersecting) {
        video.play()
      } else {
        video.pause()
      }
    }
  })
  observer.observe(element)

  return () => {
    observer.unobserve(element)
  }
})

// Toggle scroll indicator based on scroll position
select(
  '#section-main > .hero-section:first-child, #section-main > link:first-child ~ .hero-section:first-of-type',
  leadingHeroSection => {
    let mediaElement = leadingHeroSection.querySelector('.hero-media')

    observer.observe(leadingHeroSection)

    // Scroll to next element if clicking the indicator
    let scrollIndicatorButton = mediaElement.querySelector('.hero-scroll-indicator')

    // Scroll indicator click handler
    function onClick() {
      let main = document.querySelector('section.main') ?? document.body

      // Find main container
      let current = leadingHeroSection
      if (main.contains(current) && current.parentNode !== main) {
        while (current.parentNode !== main) {
          current = current.parentNode
        }
      }

      // Find succ element to scroll to
      let nextElement = current.nextElementSibling
      while (nextElement) {
        if (nextElement.offsetHeight > 0) break
        nextElement = nextElement.nextElementSibling
      }

      // Scroll to next element
      nextElement?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }

    scrollIndicatorButton?.addEventListener('click', onClick)

    return () => {
      observer.unobserve(leadingHeroSection)
      scrollIndicatorButton?.removeEventListener('click', onClick)
    }
  },
)
